import { css, cva, cx } from '@lastbrand/web-ui-styled-system/css'

import type { ReactNode } from 'react'

const groupRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
  },
  variants: {
    variant: {
      pdp: { gap: 'space-8' },
      subscription: { gap: 'space-12' },
    },
  },
  defaultVariants: { variant: 'pdp' },
})

const itemCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 'space-8',
})

const iconWrapperRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  variants: {
    size: {
      md: {},
      sm: { paddingY: 'space-2' },
    },
  },
  defaultVariants: { size: 'md' },
})

const labelRecipe = cva({
  base: {
    textStyle: 'body-14',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: 'space-4',
    rowGap: 'space-2',
    minWidth: 0,
    flex: 1,
    wordBreak: 'break-word',
  },
  variants: {
    variant: {
      default: { color: 'black' },
      green: { color: 'green-100' },
    },
  },
  defaultVariants: { variant: 'default' },
})

export interface ProductInfoItemProps {
  icon: ReactNode
  size?: 'md' | 'sm'
  variant?: 'default' | 'green'
  children: ReactNode
}

export const ProductInfoItem = ({ icon, size, variant, children }: ProductInfoItemProps) => (
  <div className={itemCss}>
    <span aria-hidden="true" className={iconWrapperRecipe({ size })}>
      {icon}
    </span>
    <span className={labelRecipe({ variant })}>{children}</span>
  </div>
)

export interface ProductInfoGroupProps {
  variant?: 'pdp' | 'subscription'
  className?: string
  children: ReactNode
}

export const ProductInfoGroup = ({ variant, className, children }: ProductInfoGroupProps) => (
  <div className={cx(groupRecipe({ variant }), className)}>{children}</div>
)
